// Area: directory (owner platform-contracts in wave 1, admin-ops in wave 2).
import { z } from 'zod';
import { MemberDTO } from '@dataroom/core';
import { defineContract } from '../define';

export { MemberDTO };

export const DirectoryMembersQuery = z.object({
  /** `active` (default) lists members who can sign in; `all` adds invited and deactivated ones. */
  status: z.enum(['active', 'all']).default('active'),
});

export const directoryMembersContract = defineContract({
  method: 'GET',
  path: '/directory/members',
  query: DirectoryMembersQuery,
  response: z.array(MemberDTO),
  summary: 'Members of the workspace (id, name, initials, avatar color, role)',
});
